import tablaLoader from "@assets/tabla-preloader.lottie";
import { getWindowOrigin } from "@helper/utils";
import { DotLottie } from "@lottiefiles/dotlottie-web";
import { useEffect, useState } from "react";

export default function TablaLottieLoader() {
  const [lottieReady, setlottieReady] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      setlottieReady(1);
    }, 800);
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined" && lottieReady) {
      const canvasDoc = document.getElementById("dotlottie-canvas");

      if (canvasDoc instanceof HTMLCanvasElement) {
        const width = canvasDoc.offsetWidth || 1024;
        const BASE_URL = getWindowOrigin();
        const TablaLoadingAnimation = BASE_URL + tablaLoader;

        new DotLottie({
          autoplay: true,
          loop: true,
          canvas: canvasDoc,
          src: TablaLoadingAnimation,
        });
        const height_ratio = width > 768 ? 0.105 : width > 575 ? 0.143 : 0.2;
        const minCanvasHeight = `${width > 768 ? 170 : 110}px`;
        canvasDoc.style.height = `${width * height_ratio}px`;
        canvasDoc.style.minHeight = minCanvasHeight;
      }
    }
  }, [lottieReady]);

  return (
    <>
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row justify-between xmd:gap-5">
        <div className="justify-items-center my-10 md:my-0 lg:my-10 w-full lg:w-[860px] lg:pr-md xmd:py-x1s">
          <canvas
            id="dotlottie-canvas"
            className="w-[125px] h-[158px]"
          ></canvas>
        </div>
        <div className="hidden lg:block max-w-1/3 lg:w-[400px] flex-col"></div>
      </div>
    </>
  );
}
